import Vue from 'vue'
import axios from 'axios'
import '../../components/partials/santander/SantanderFilter.js';
import SolAgoraService from "@/services/SolAgoraService";

const initialState = {
    projeto: {
        mensagemListaGeradores: '',
        id: '',
        etapa: 0,
        produto: 0,
        cliente: {
            nome: '',
            email: '',
            telefone1: '',
            telefone2: '',
            estado: 'AC',
            cidade: '',
            parcelaSelecionada: {},
            parcelasFinanciamento: [],
            parcelasCartao: []
        },
        contas: [],
        filtros: {
            familia: 0,
            estrutura: 0,
            inversor: 0,
            painel: 0,
            tensao: 0,
            cobertura: 100
        },
        valorEUP: '0',
        informacoesInstalacao: '',
        modoPagamento: '0',
        prazoEntrega: 0,
        observacoes: '',
        contatoRevenda: {
            cnpj: '',
            nome: '',
            empresa: '',
            site: '',
            email: '',
            telefone: '',
            cep: '',
            endereco: '',
            bairro: '',
            estado: 'AC',
            imagem: '',
            imagemBase64: ''
        },
        transportadora: {}
    },
    etapas: [{ Id: 1, name: 'Em Negociação' }, { Id: 2, name: 'Aguardando Concessionária' }, { Id: 3, name: 'Pedidos Efetivados' }, { Id: 0, name: 'Projetos Concluído' }],
    selectedProduct: null,
    caracteristicasBasicas: {
        area: '',
        generatorCapacity: '',
        weight: ''
    },
    components: [],
    descricaoSimplificada: '',
    generatorImage: '',
    potenciaGerador: '',
    step: 1,
    familias: [{ Id: 0, Valor: 'Todas' }],
    estruturas: [{ Id: 0, Valor: 'Todas' }],
    tensoes: [{ Id: 0, Valor: 'Todas' }],
    inversores: [{ Id: 0, Valor: 'Todos' }],
    paineis: [{ Id: 0, Valor: 'Todos' }],
    geradores: [],
    estados: [],
    parcelas: [
        {
            code: 11,
            label: 'Financiamento Santander'
        }
    ],
    valoresParcelas: []
}

const state = {
    projeto: {
        mensagemListaGeradores: '',
        id: '',
        etapa: 1,
        produto: 0,
        cliente: {
            nome: '',
            email: '',
            telefone1: '',
            telefone2: '',
            estado: 'AC',
            cidade: '',
            parcela: null,
            parcelaSelecionada: {},
            parcelasFinanciamento: [],
            parcelasCartao: []
        },
        contas: [],
        filtros: {
            familia: 0,
            estrutura: 0,
            inversor: 0,
            painel: 0,
            tensao: 0,
            cobertura: 100
        },
        valorEUP: '0',
        informacoesInstalacao: '',
        modoPagamento: '0',
        prazoEntrega: 0,
        observacoes: '',
        contatoRevenda: {
            nome: '',
            empresa: '',
            site: '',
            email: '',
            telefone: '',
            cep: '',
            endereco: '',
            bairro: '',
            estado: 'AC',
            imagem: '',
            imagemBase64: ''
        },
        transportadora: {}
    },
    etapas: [{ Id: 1, name: 'Em Negociação' }, { Id: 2, name: 'Aguardando Concessionária' }, { Id: 3, name: 'Pedidos Efetivados' }, { Id: 0, name: 'Projetos Concluído' }],
    selectedProduct: null,
    caracteristicasBasicas: {
        area: '',
        generatorCapacity: '',
        weight: ''
    },
    components: [],
    generatorImage: '',
    potenciaGerador: '',
    descricaoSimplificada: '',
    step: 1,
    familias: [{ Id: 0, Valor: 'Todas' }],
    estruturas: [{ Id: 0, Valor: 'Todas' }],
    tensoes: [{ Id: 0, Valor: 'Todas' }],
    inversores: [{ Id: 0, Valor: 'Todos' }],
    paineis: [{ Id: 0, Valor: 'Todos' }],
    geradores: [],
    estados: [],
    parcelas: [
        {
            code: 11,
            label: 'Financiamento Santander'
        }
    ],
    valoresParcelas: []
};

const getters = {
    mensagemListaGeradores: state => state.projeto.mensagemListaGeradores,
    caracteristicasBasicas: state => state.caracteristicasBasicas,
    components: state => state.components,
    generatorImage: state => state.generatorImage,
    potenciaGerador: state => state.potenciaGerador,
    descricaoSimplificada: state => state.descricaoSimplificada,
    projeto: state => state.projeto,
    familias: state => state.familias,
    estruturas: state => state.estruturas,
    tensoes: state => state.tensoes,
    inversores: state => state.inversores,
    paineis: state => state.paineis,
    geradores: state => state.geradores,
    selectedProduct: state => state.selectedProduct,
    estados: state => state.estados,
    step: state => state.step,
    parcelas: state => state.parcelas,
    valoresParcelas: state => state.valoresParcelas
}

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
    clearFiltros({ commit }) {
        commit('resetFilters');
    },
    async loadProject({ commit, state, dispatch }, {id, desktop}) {
        let response
        if (desktop) {
            response = await axios.get(`${Vue.prototype.$apiUrl}/Projeto.svc/projeto/desktop/${id}`, { withCredentials: false })
        }else {
            response = await axios.get(`${Vue.prototype.$apiUrl}/Projeto.svc/projeto/${id}`, { withCredentials: true })
        }

        const projeto = response.data;
        let parcelas = [];

        if (projeto.cliente.parcelaSelecionada.valor != null) {
            let valor = projeto.cliente.parcelaSelecionada.valor;
            let quantidade = projeto.cliente.parcelaSelecionada.quantidade;

            if (!projeto.valoresParcelas || projeto.valoresParcelas.length == 0) {
                let parcela = {
                    quantidade: quantidade,
                    valor: valor,
                    label: quantidade + " x " + Vue.options.filters.reais(valor),
                };
                parcelas.push(parcela);
                commit("setValoresParcelas", parcelas);
                projeto.cliente.parcelaSelecionada = parcelas[0];
            }
        }

        // console.log(projeto.contas[0].consumoKwh)
        const url = `${Vue.prototype.$apiUrl}Produto.svc/getproduto/${projeto.produto}?naoMostrarInternet=true`;
        let responseProduct = await axios.get(url, { withCredentials: true });
        // console.log(responseProduct);

        responseProduct = responseProduct.data;
        responseProduct.PRD_DESCR1 = responseProduct.PRD_DESCR1.replace(/#IMPORTANTE#/g, '').replace(/#LINHA#/g, '');

        commit('setSelectedProduct', responseProduct);
        dispatch('setdescricaoSimplificada', projeto.produto);
        commit('setProjeto', projeto);
    },
    async loadContatoRevenda({ commit }) {
        const url = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/getcontatorevenda/`;
        const response = await axios.get(url, { withCredentials: true });
        commit('setContatoRevenda', response.data)
    },
    async loadEstados({ commit }) {
        const jsonData = await $.getJSON(`${document.location.protocol}/assets/json/data_solar.json`);
        // let estados = new Map([...new Set(solarData.map(item => item.uf))].sort().map(item => [item, []]));
        // solarData.map((item => {
        //   estados.get(item.uf).push(item.municipio)
        // }));
        let estados = [];
        let solarData = await axios.get(`${Vue.prototype.$apiUrl}CalculadoraSolar.svc/locations`)
            .then((response) => {
                return response.data;
            })

        solarData.forEach((element) => {
            element.uf = jsonData.filter(c => c.estado == element.State)[0].uf;
        })

        estados = new Map([...new Set(solarData.map(item => item.uf))].sort().map(item => [item, []]));
        solarData.map((item => {
            estados.get(item.uf).push(item.City)
        }));

        commit('loadEstados', estados)
    },
    // async loadValoresParcelas({ commit }) {
    //     const {
    //         projeto: { valorEUP }
    //     } = state;

    //     let parcelas = [];
    //     await axios.post(Vue.prototype.$apiUrl + "Santander.svc/parcelas", {
    //         total: valorEUP.replace('.', '').replace(',', '.')
    //     }).then((response) => {
    //         parcelas = response.data;
    //     })

    //     parcelas.forEach((element, index) => {
    //         if (index == 0)
    //             element.label = element.quantidade + " x R$ " + element.valor + " no boleto";
    //         else
    //             element.label = element.quantidade + " x R$ " + element.valor + " com juros no boleto";
    //     })

    //     commit('setValoresParcelas', parcelas);
    // },
    async calculatePotencia({ commit }) {
        let solarIncidence,
            generatorCapacity = 0

        const {
            projeto: { cliente, contas }
        } = state
        // eslint-disable-next-line no-undef
        // const solarData = await $.getJSON(`${document.location.protocol}/assets/json/data_solar.json`);
        // const filteredData = solarData.filter(
        //   data => data.municipio === cliente.cidade && data.uf === cliente.estado
        // )
        // if (filteredData.length > 0) {
        //   solarIncidence = filteredData[0].incidencia_solar_anual
        // }

        let urlLocal = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/location/${cliente.cidade}`;
        solarIncidence = await axios.get(urlLocal).then((response) => {
            return response.data.SolarIncidence;
        })

        const sumOfMonthlyConsumption = contas.reduce(
            (accumulator, currentValue) =>
                accumulator + Number(currentValue.consumoMensal),
            0
        ) * (state.projeto.filtros.cobertura / 100);

        if (solarIncidence !== 0) {
            solarIncidence = solarIncidence - ((12.6 / 100) * solarIncidence);
            generatorCapacity = sumOfMonthlyConsumption / 30 / solarIncidence;
        }

        commit('setCaracteristicasBasicas', { generatorCapacity })

        return generatorCapacity;
    },
    async calculateProject({ commit, dispatch, state }) {
        let solarIncidence,
            generatorCapacity = 0

        const {
            projeto: { cliente, contas }
        } = state
        // eslint-disable-next-line no-undef
        // const solarData = await $.getJSON(`${document.location.protocol}/assets/json/data_solar.json`);
        // const filteredData = solarData.filter(
        //   data => data.municipio === cliente.cidade && data.uf === cliente.estado
        // )
        // if (filteredData.length > 0) {
        //   solarIncidence = filteredData[0].incidencia_solar_anual
        // }

        let urlLocal = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/location/${cliente.cidade}`;
        solarIncidence = await axios.get(urlLocal).then((response) => {
            return response.data.SolarIncidence;
        })

        const sumOfMonthlyConsumption = contas.reduce(
            (accumulator, currentValue) =>
                accumulator + Number(currentValue.consumoMensal),
            0
        ) * (state.projeto.filtros.cobertura / 100);

        if (solarIncidence !== 0) {
            solarIncidence = solarIncidence - ((12.6 / 100) * solarIncidence);
            generatorCapacity = sumOfMonthlyConsumption / 30 / solarIncidence
        }

        const area = (generatorCapacity * 1000 / 335 * 2.3);
        const weight = area * 18;

        commit('setCaracteristicasBasicas', { area, generatorCapacity, weight })
        dispatch('fetchGenerators')
        dispatch('nextStep')
    },
    async fetchSelectors({ commit }) {
        const url = `${Vue.prototype.$apiUrl
            }CalculadoraSolar.svc/getatributoscalculadora`

        const {
            caracteristicasBasicas: { generatorCapacity }
        } = state

        const response = await axios.post(`${url}`,
            {
                potencia: generatorCapacity
            });

        let filtros = response.data;

        if (filtros == null)
            return;

        filtros.forEach((element) => {
            if (element.Nome == 'FAMILIA') {
                let familias = element.Atributos;
                familias.unshift({ Id: 0, Valor: 'Todas' })
                commit('setFamilias', familias)
            }
            else if (element.Nome == 'TIPO_ESTRUTURA') {
                let estruturas = element.Atributos;
                estruturas.unshift({ Id: 0, Valor: 'Todas' })
                commit('setEstruturas', estruturas)
            }
            else if (element.Nome == 'TENSAO_SAIDA') {
                let tensoes = element.Atributos;
                tensoes.unshift({ Id: 0, Valor: 'Todas' })
                commit('setTensoes', tensoes)
            }
            else if (element.Nome == 'MARCA_INVERSOR') {
                let inversores = element.Atributos;
                inversores.unshift({ Id: 0, Valor: 'Todos' })
                commit('setInversores', inversores)
            }
            else if (element.Nome == 'MARCA_PAINEL') {
                let paineis = element.Atributos;
                paineis.unshift({ Id: 0, Valor: 'Todos' })
                commit('setPaineis', paineis)
            }
        })
    },
    async fetchGenerators({ commit, state }) {
        const url = `${Vue.prototype.$apiUrl}Produto.svc/getlistagerador`
        const {
            projeto: {
                filtros: { estrutura, familia, inversor, painel, tensao }
            },
            caracteristicasBasicas: { generatorCapacity }
        } = state

        const response = await axios.post(url, {
            estrutura,
            familia,
            inversor,
            painel,
            tensao,
            potencia: generatorCapacity
        }, { withCredentials: true })

        // const response = await axios.post(url, {
        //   cliente: 4466,
        //   potencia: 10,
        //   estrutura: 0,
        //   painel: 0
        // })
        const { data } = response
        let geradores = []

        data.forEach(element => {
            let produto = {}
            produto.id = element.PRD_CODIGO
            produto.code = element.PRD_CODIGO + '-' + element.PRD_CODIGODV
            produto.name = element.PSG_DESCRICAO + ' ' + element.PGR_DESCRICAO
            produto.state = 'PR'
            produto.img = element.PRD_CAMINHO
            produto.description = element.PRD_DESCRICAO

            const productDesc =
                produto.name
                    .replace(/\s+/g, '-')
                    .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
                    .toLowerCase() +
                '-' +
                element.PRD_DESCRICAO.trim()
                    .replace(/\s+/g, '-')
                    .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
                    .toLowerCase()

            produto.url = '/loja/produto/' + produto.code + '/' + productDesc
            produto.price = element.PRECOPRODUTO
            produto.showActions = false
            produto.isLogged = element.IS_LOGGED
            geradores.push(produto)
        })

        if (geradores.length > 100) {
            geradores = geradores.slice(0, 100);
            commit('setMensagemListaGeradores', 'Foram selecionados apenas 100 geradores compatíveis')
        }
        else
            commit('setMensagemListaGeradores', `Foram encontrados ${geradores.length} geradores compatíveis`)

        commit('setGeradores', geradores)
    },
    addBill({ commit }) {
        commit('newBill')
    },
    removeBill({ commit, state }, index) {
        const contas = [...state.projeto.contas]
        contas.splice(index, 1)
        commit('setContas', contas)
    },
    nextStep({ commit }) {
        const el = document.getElementById('calculadora')
        if (el) el.scrollIntoView();
        commit('nextStep')
    },
    setStep({ commit }, step) {
        const el = document.getElementById('calculadora')
        if (el) el.scrollIntoView();
        commit('setStep', step)
    },
    previousStep({ commit }) {
        document.getElementById('calculadora').scrollIntoView();
        commit('previousStep')
    },
    async selectProduct({ commit, dispatch }, product) {
        const url = `${Vue.prototype.$apiUrl}Produto.svc/getproduto/${product.id}?naoMostrarInternet=true`;
        const response = await axios.get(url, { withCredentials: true });
        let responseProduct = response.data;
        const valorFrete = state.projeto.transportadora && state.projeto.transportadora.Taxa ? state.projeto.transportadora.Taxa : 0;
        responseProduct.PRD_DESCR1 = responseProduct.PRD_DESCR1.replace(/#IMPORTANTE#/g, '').replace(/#LINHA#/g, '');
        document.getElementById('calculadora').scrollIntoView();
        commit('setSelectedProduct', responseProduct);
        commit('setValorEUP', (responseProduct.PrecoEUP + valorFrete).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        dispatch('setComponents', product.id);
        dispatch('setdescricaoSimplificada', product.id);
        dispatch('setGeneratorImage', product.id);
        dispatch('setpotenciaGerador', product.id);
    },

    async selectTransportadora({ commit }, transportadora) {
        commit('setTransportadora', transportadora);
    },

    async setComponents({ commit }, productId) {
        const urlMaterias = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/getmateriasprimas/${productId}`;
        const responseMaterias = await axios.get(urlMaterias);
        commit('setComponents', responseMaterias.data)
    },

    async setdescricaoSimplificada({ commit }, productId) {
        const urlDescricao = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/getDescricaoProdutoSimplicada/${productId}`;
        const responseDescricao = await axios.get(urlDescricao);
        commit('setdescricaoSimplificada', responseDescricao.data)
    },

    async setGeneratorImage({ commit }, productId) {
        const urlGeneratorImage = `${Vue.prototype.$apiUrl}Produto.svc/getimagemgerador/${productId}`;
        const responseGeneratorImage = await axios.get(urlGeneratorImage);
        commit('setGeneratorImage', responseGeneratorImage.data)
    },

    async setpotenciaGerador({ commit }, productId) {
        const urlpotenciaGerador = `${Vue.prototype.$apiUrl}CalculadoraSolar.svc/getPotenciaGerador/${productId}`;
        const responsepotenciaGerador = await axios.get(urlpotenciaGerador);
        commit('setpotenciaGerador', responsepotenciaGerador.data)
    },

    async getValoresParcelamentoCartao({ commit }, { codigoProduto, valor }) {

        await axios
            .post(
                Vue.prototype.$apiUrl + "PagamentoCartao.svc/CreditCardProductInterestRates",
                { codigoPedido: -1, codigoProduto: codigoProduto, valorProduto: valor, bandeira: 1 },
                { withCredentials: true })
            .then((response) => {
                if (response.data) {
                    const optionsParcela = response.data.map((x) => (
                        {
                            parcela: x.InstallmentNumber,
                            valor: (x.FinalValue / x.InstallmentNumber),
                        }));

                        commit('setParcelasCartao', optionsParcela);
                }
            });
    },

    async getValoresParcelamentoSolAgora({ commit }, { cnpj, valor, cpfCliente, valorConta }) {

        commit('setParcelasFinanciamento', [])

        try {
            const res = await SolAgoraService.CheckIntegrator({ apiUrl: Vue.prototype.$apiUrl, cnpj: cnpj })
            if (!res.data.Active) return
        } catch { return; }

        const auth = await SolAgoraService.GetToken({ apiUrl: Vue.prototype.$apiUrl });

        if (!auth) return;

        const token = auth.data.AccessToken;
        const documento = cpfCliente;

        const res = await SolAgoraService.OpenSimulate({
            apiUrl: Vue.prototype.$apiUrl,
            token: token,
            price: valor,
            monthly_income: 1000000,
            document: documento,
        });

        if (res.data && res.data.Parcelas && res.data.Parcelas.length) {
            const optionsParcela = res.data.Parcelas.map((x) => ({ parcela: x.Prazo, valor: x.VlrParcela }));

            const parcelas = [];

            const parcelaSugerida = optionsParcela.filter(
                (x) => x.valor <= valorConta
            ).sort((x, y) => y.valor - x.valor)[0];

            if (parcelaSugerida) parcelas.push({ best: 1, ...parcelaSugerida });

            optionsParcela.forEach(x => {
                if (parcelas.length <= 6 && x.parcela % 12 == 0)
                    parcelas.push(x);
            })

            commit('setParcelasFinanciamento', parcelas.sort((a, b) => {
                if (a.best && !b.best) return -1;
                else if (!a.best && b.best) return 1;
                else return a.parcela - b.parcela
            }));
        }
    },

    deselectProduct({ commit }) {
        commit('setSelectedProduct', null)
    },
    updateProject({ commit }, projeto) {
        commit('forceReloadState', projeto)
    }
}

const mutations = {
    resetState: (state) => {
        // console.log("RESET STATE")
        // console.log(initialState)
        state.projeto = initialState.projeto;
        state.valorEUP = initialState.valorEUP;
        state.step = initialState.step;
        state.caracteristicasBasicas = initialState.caracteristicasBasicas;
        state.components = initialState.components;
        state.generatorImage = initialState.generatorImage;
        state.potenciaGerador = initialState.potenciaGerador;
        state.descricaoSimplificada = initialState.descricaoSimplificada;
        state.selectedProduct = initialState.selectedProduct;
        state.etapas = initialState.etapas;
        state.familias = initialState.familias;
        state.estruturas = initialState.estruturas;
        state.tensoes = initialState.tensoes;
        state.inversores = initialState.inversores;
        state.paineis = initialState.paineis;
        state.geradores = initialState.geradores;
        state.estados = initialState.estados;
    },
    resetFilters: (state) => {
        state.projeto.filtros.familia = 0;
        state.projeto.filtros.estrutura = 0;
        state.projeto.filtros.inversor = 0;
        state.projeto.filtros.painel = 0;
        state.projeto.filtros.tensao = 0;
    },
    setMensagemListaGeradores: (state, mensagem) => state.projeto.mensagemListaGeradores = mensagem,
    setComponents: (state, components) => state.components = components,
    setGeneratorImage: (state, generatorImage) => state.generatorImage = generatorImage,
    setpotenciaGerador: (state, potenciaGerador) => state.potenciaGerador = potenciaGerador,
    setdescricaoSimplificada: (state, descricaoSimplificada) => state.descricaoSimplificada = descricaoSimplificada,
    forceReloadState: (state, projeto) => state.projeto = projeto,
    setContatoRevenda: (state, contatoRevenda) => state.projeto.contatoRevenda = contatoRevenda,
    loadEstados: (state, estados) => state.estados = estados,
    setParcelas: (state, parcelas) => state.parcelas = parcelas,
    setValoresParcelas: (state, valoresParcelas) => state.valoresParcelas = valoresParcelas,
    setValorParcela: (state, valorParcela) => state.projeto.cliente.parcelaSelecionada.valor = valorParcela,
    setParcelasFinanciamento: (state, parcelasFinanciamento) => state.projeto.cliente.parcelasFinanciamento = parcelasFinanciamento,
    setParcelasCartao: (state, parcelasCartao) => state.projeto.cliente.parcelasCartao = parcelasCartao,
    setTransportadora: (state, transportadora) => (state.projeto.transportadora = transportadora),
    nextStep: state => state.step++,
    newBill: state => {
        if (state.projeto.contas.length < 5) {
            state.projeto.contas.push({ tipo: '0', valor: '', consumoMensal: '', consumoKwh: '' })
        }
    },
    previousStep: state => state.step--,
    setCaracteristicasBasicas: (state, caracteristicasBasicas) =>
        (state.caracteristicasBasicas = caracteristicasBasicas),
    setContas: (state, contas) => (state.projeto.contas = contas),
    setEstruturas: (state, estruturas) => (state.estruturas = estruturas),
    setFamilias: (state, familias) => (state.familias = familias),
    setGeradores: (state, geradores) => (state.geradores = geradores),
    setInversores: (state, inversores) => (state.inversores = inversores),
    setPaineis: (state, paineis) => (state.paineis = paineis),
    setProjeto: (state, projeto) => (state.projeto = projeto),
    setStep: (state, step) => (state.step = step),
    setSelectedProduct: (state, selectedProduct) => {
        state.selectedProduct = selectedProduct;
        state.projeto.produto = selectedProduct.PRD_CODIGO;
        return state;
    },
    setTensoes: (state, tensoes) => (state.tensoes = tensoes),
    setValorEUP: (state, valorEUP) => (state.projeto.valorEUP = valorEUP)
}

export default {
    state,
    getters,
    actions,
    mutations
}
